import { API_BASE_URL } from '@/constants/api'
import { ModalsModel } from '@/models'
import setAuthorization from '@/utils/helpers/setAuthorization'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const modalsRepository = createApi({
	reducerPath: 'modalsRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	refetchOnReconnect: true,
	tagTypes: ['Modals'],

	endpoints: (builder) => ({
		list: builder.query<ModalsModel.List, void>({
			query: () => ({
				url: `/v1/modals`,
				method: 'GET',
			}),
			providesTags: ['Modals'],
		}),
	}),
})

export default modalsRepository
